import { connect } from 'react-redux';
import { Global } from 'state/Global';
import { actions as selectionActions } from '../../actions/selectionActions';
import { InfiniteTable } from '../../components/InfiniteTable/InfiniteTable';
import { selectFilterString } from '../../selectors/filterSelectors';
import { selectPageNumber } from '../../selectors/paginationSelectors';
import { selectIsSelectAll, selectSelection } from '../../selectors/selectionSelectors';

const mapStateToProps = (state: Global) => {
  const hasSearchString = !!selectFilterString(state).length;
  return {
    allRowsSelected: selectIsSelectAll(state),
    hasSearchString: hasSearchString,
    pageNumber: selectPageNumber(state),
    selectionArray: selectSelection(state),
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  resetSelection: () => {
    dispatch(selectionActions.resetSelection());
  },
  toggleAll: (dataUUIDs: string[]) => {
    dispatch(selectionActions.toggleAll(dataUUIDs));
  },
  toggleSelection: (key: number) => {
    dispatch(selectionActions.toggleSelection(key));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(InfiniteTable);
